export default function formatName(user) {
  if (!user) return null;
  return `${user.firstName} ${user.lastName}`;
}
